var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"purchase-limit-hint"},[_vm._v(" Individual ticket purchase limit exceeded. "),(_vm.isMobileScreen)?_c('br'):_vm._e(),_vm._v(" "+_vm._s(_vm.purchaseLimit)+" tickets max ")])
}
var staticRenderFns = []

export { render, staticRenderFns }